import "./App.css";

import Intro from "./components/Intro";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Footer from "./components/Footer";
import Contact from "./components/Contact";


function App() {
  return (
    <main className="app">

      <Intro />

      <div className="container">
        <section className="section">
          <About />
        </section>

        <section className="section">
          <Projects />
        </section>

        <section className="section">
          <Skills />
        </section>

        <section id="contact" className="section">
    <Contact />
</section>

      </div>

      <Footer />

    </main>
  );
}
export default App;